export {
    PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_FORM_SERVICE_NAME,
    PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_FORM_SERVICE_PROVIDER_NAME,
    PecGliwiceDataTypeGroupCreateEditFormService,
    PecGliwiceDataTypeGroupCreateEditFormServiceProvider,
} from './pec-gliwice-data-type-group-create-edit.service'

export { PEC_GLIWICE_DATA_TYPE_GROUP_CREATE_EDIT_FORM_SERVICES_MODULE_NAME } from './pec-gliwice-data-type-group-create-edit.service.module'